import { useFormikContext } from 'formik';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import Sidebar from '../Sidebar';
import { useResponsive } from '@/hooks';

const Design = () => {
  const { isMobile } = useResponsive();
  const { values, handleChange } = useFormikContext<{
    design: 'yes' | 'no' | 'changes';
  }>();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 9 }}>
        <Stack spacing={2} flex={1}>
          <Paper
            sx={{
              padding: 3,
            }}
          >
            <FormControl>
              <FormLabel id="design-group-label">
                ¿ Ya tienes tu Diseño ?
              </FormLabel>
              <RadioGroup
                value={values.design}
                name="design"
                onChange={handleChange}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Si, ya cuento con uno."
                />
                <FormControlLabel
                  value="changes"
                  control={<Radio />}
                  label="Si, pero necesito cambios."
                />
                <FormControlLabel
                  value="no"
                  control={<Radio />}
                  label="No, necesitaría sus servicios."
                />
              </RadioGroup>
            </FormControl>
          </Paper>
        </Stack>
      </Grid>
      {!isMobile ? (
        <Grid size={{ xs: 12, md: 3 }}>
          <Sidebar />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Design;
